const ExclamationIcon = ({ className }: { className?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7.99984 2.33317C4.87022 2.33317 2.33317 4.87022 2.33317 7.99984C2.33317 11.1295 4.87022 13.6665 7.99984 13.6665C11.1295 13.6665 13.6665 11.1295 13.6665 7.99984C13.6665 4.87022 11.1295 2.33317 7.99984 2.33317ZM1.6665 7.99984C1.6665 4.50203 4.50203 1.6665 7.99984 1.6665C11.4976 1.6665 14.3332 4.50203 14.3332 7.99984C14.3332 11.4976 11.4976 14.3332 7.99984 14.3332C4.50203 14.3332 1.6665 11.4976 1.6665 7.99984Z'
      fill='currentColor'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.00016 3.6665C8.18426 3.6665 8.3335 3.81574 8.3335 3.99984V8.6665C8.3335 8.8506 8.18426 8.99984 8.00016 8.99984C7.81607 8.99984 7.66683 8.8506 7.66683 8.6665V3.99984C7.66683 3.81574 7.81607 3.6665 8.00016 3.6665Z'
      fill='currentColor'
    />
    <path
      d='M8.66683 10.6665C8.66683 11.0347 8.36835 11.3332 8.00016 11.3332C7.63197 11.3332 7.3335 11.0347 7.3335 10.6665C7.3335 10.2983 7.63197 9.99984 8.00016 9.99984C8.36835 9.99984 8.66683 10.2983 8.66683 10.6665Z'
      fill='currentColor'
    />
  </svg>
)

export default ExclamationIcon
